export const RIA_COMMENTS_APP = 'RIA_COMMENTS_APP';
export const RIA_COMMENTS_EMBED_SCRIPT = 'RIA_COMMENTS_EMBED_SCRIPT';
export const FULL_WIDTH_BREAK_POINT = 820;
